"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "useDropdownChevronBackground", {
    enumerable: true,
    get: function() {
        return useDropdownChevronBackground;
    }
});
const _react = require("react");
const useDropdownChevronBackground = (param)=>{
    let { color } = param;
    return (0, _react.useMemo)(()=>{
        const svg = "<svg width='16' height='16' viewBox='0 0 16 16' fill='".concat(color, "' xmlns='http://www.w3.org/2000/svg'><path d='M7.99999 8.78145L11.3 5.48145L12.2427 6.42411L7.99999 10.6668L3.75732 6.42411L4.69999 5.48145L7.99999 8.78145Z' /></svg>");
        return 'url("data:image/svg+xml;base64,'.concat(btoa(svg), '")');
    }, [
        color
    ]);
};

//# sourceMappingURL=useDropdownChevronBackground.js.map